import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { CustomerSupplierListType } from "../../../redux/clientSettings/clientSettingTypes";
import { Loader } from "../../commons";
import ".././Reports.scss";
import { formatDate } from "../../../utils/commonFunctions";
type AppProps = {
  isOpen: boolean;
  fetching?: boolean;
  setRedirectToCustomerSuplier?: (data: boolean) => void;
  toggle: () => void;
  client_code: number;
  isEditCustomerSupplierPresent: boolean;
  company_name: string;
  singleCustomerSupplier: CustomerSupplierListType;
  currencySign?: string | undefined;
};

const ViewEditCustomerSuplierModal = ({
  isOpen,
  toggle,
  setRedirectToCustomerSuplier,
  isEditCustomerSupplierPresent,
  singleCustomerSupplier,
  client_code,
  fetching,
  company_name,
  currencySign,
}: AppProps) => {
  const [onCancel, setOnCancel] = useState(isOpen);
  const handleSetLocalStorageData = () => {
    setRedirectToCustomerSuplier?.(true);
    toggle();
  };

  const redirectLink = `/client-settings/customers-suppliers/edit/${client_code}/${singleCustomerSupplier?.ledger_id}?client_code=${client_code}&company_name=${company_name}`;

  return (
    <>
      <Modal isOpen={onCancel} toggle={() => setOnCancel(true)} size="lg">
        <ModalHeader className="pt-4 pl-4" toggle={toggle}>
          {singleCustomerSupplier?.legal_name}
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12 ml-3">
            <div className="row">
              <div className="col-md-4">
                <label>Type</label>
                <br />
                <span className="text-color">
                  {singleCustomerSupplier?.type
                    ? singleCustomerSupplier?.type
                    : "N/A"}
                </span>
              </div>
              <div className="col-md-4">
                <label>Unique Number</label>
                <br />
                <span className="text-color">
                  {singleCustomerSupplier?.ledger_number
                    ? singleCustomerSupplier?.ledger_number
                    : "N/A"}
                </span>
              </div>
              <div className="col-md-4">
                <label>Last Balance</label>
                <br />
                <span className="text-color">
                  <span className="pending">
                    {currencySign}
                    {singleCustomerSupplier?.customer_balance
                      ? singleCustomerSupplier?.customer_balance
                      : singleCustomerSupplier?.supplier_balance
                      ? singleCustomerSupplier?.supplier_balance
                      : 0}
                  </span>{" "}
                  <br />
                  <span className="text-muted" style={{ fontSize: "10px" }}>
                    {""}
                    As of{" "}
                    {singleCustomerSupplier?.supplier_date_of_last_balance &&
                      formatDate(
                        singleCustomerSupplier?.supplier_date_of_last_balance
                      )}
                    {singleCustomerSupplier?.customer_date_of_last_balance &&
                      formatDate(
                        singleCustomerSupplier?.customer_date_of_last_balance
                      )}
                  </span>
                </span>
              </div>
            </div>
            <div className="mt-4">
              <h6>BUSINESS DETAILS</h6>
              <div className="row">
                <div className="col-md-4">
                  <label>Pan Number</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.pan_number
                      ? singleCustomerSupplier?.pan_number
                      : "N/A"}
                  </span>
                </div>
                <div className="col-md-4">
                  <label>Legal Name</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.legal_name
                      ? singleCustomerSupplier?.legal_name
                      : "N/A"}
                  </span>
                </div>
                <div className="col-md-4">
                  <label>Trade Name</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.trade_name
                      ? singleCustomerSupplier?.trade_name
                      : "N/A"}
                  </span>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-4">
                  <label>GST Number</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.gst_number
                      ? singleCustomerSupplier?.gst_number
                      : "N/A"}
                  </span>
                </div>
                <div className="col-md-4">
                  <label>Registration Type</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.registration_type
                      ? singleCustomerSupplier?.registration_type
                      : "N/A"}
                  </span>
                </div>
                <div className="col-md-4">
                  <label>Registration Date</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.registration_date
                      ? singleCustomerSupplier?.registration_date
                      : "N/A"}
                  </span>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-4">
                  <label>Constitution of Business</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.constitution_of_business
                      ? singleCustomerSupplier?.constitution_of_business
                      : "N/A"}
                  </span>
                </div>
                <div className="col-md-4">
                  <label>Company Status</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.company_status
                      ? singleCustomerSupplier?.company_status
                      : "N/A"}
                  </span>
                </div>
              </div>
            </div>
            <div className="mt-4">
              <h6>CONTACT DETAILS</h6>
              <div className="row">
                <div className="col-md-8">
                  <label>Address</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.address1
                      ? singleCustomerSupplier?.address1
                      : "N/A"}
                  </span>
                </div>
                <div className="col-md-4">
                  <label>City</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.city
                      ? singleCustomerSupplier?.city?.label
                      : "N/A"}
                  </span>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-4">
                  <label>Pin Code</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.pincode
                      ? singleCustomerSupplier?.pincode
                      : "N/A"}
                  </span>
                </div>
                <div className="col-md-4">
                  <label>State</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.state
                      ? singleCustomerSupplier?.state?.label
                      : "N/A"}
                  </span>
                </div>
                <div className="col-md-4">
                  <label>Country</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.country
                      ? singleCustomerSupplier?.country?.label
                      : "N/A"}
                  </span>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-4">
                  <label>Mobile Number</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.mobile
                      ? singleCustomerSupplier?.mobile
                      : "N/A"}
                  </span>
                </div>
                <div className="col-md-4">
                  <label>Telephone Number</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.telephone
                      ? singleCustomerSupplier?.telephone
                      : "N/A"}
                  </span>
                </div>
                <div className="col-md-4">
                  <label>Email</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.email
                      ? singleCustomerSupplier?.email
                      : "N/A"}
                  </span>
                </div>
              </div>
            </div>
            <div className="mt-4">
              <h6>BANK DETAILS</h6>
              <div className="row">
                <div className="col-md-4">
                  <label>Account Number</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.payment_details?.bank_details
                      ?.account_no
                      ? singleCustomerSupplier?.payment_details?.bank_details
                          ?.account_no
                      : "N/A"}
                  </span>
                </div>
                <div className="col-md-4">
                  <label>Bank Name</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.payment_details?.bank_details
                      ?.bank_name
                      ? singleCustomerSupplier?.payment_details?.bank_details
                          ?.bank_name
                      : "N/A"}
                  </span>
                </div>
                <div className="col-md-4">
                  <label>Beneficiary Name</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.payment_details?.bank_details
                      ?.beneficiary_name
                      ? singleCustomerSupplier?.payment_details?.bank_details
                          ?.beneficiary_name
                      : "N/A"}
                  </span>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-4">
                  <label>IFSC Code</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.payment_details?.bank_details
                      ?.ifsc_code
                      ? singleCustomerSupplier?.payment_details?.bank_details
                          ?.ifsc_code
                      : "N/A"}
                  </span>
                </div>
                <div className="col-md-4">
                  <label>Swift Code</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.payment_details?.bank_details
                      ?.swift_code
                      ? singleCustomerSupplier?.payment_details?.bank_details
                          ?.swift_code
                      : "N/A"}
                  </span>
                </div>
                <div className="col-md-4">
                  <label>Bank Branch Address</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.payment_details?.bank_details
                      ?.bank_branch_address
                      ? singleCustomerSupplier?.payment_details?.bank_details
                          ?.bank_branch_address
                      : "N/A"}
                  </span>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-4">
                  <label>City</label>
                  <br />
                  <span className="text-color">
                    {singleCustomerSupplier?.payment_details?.bank_details?.city
                      ? singleCustomerSupplier?.payment_details?.bank_details
                          ?.city
                      : "N/A"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <span
            className="pointer btn"
            style={{ border: "1px solid" }}
            onClick={() => {
              toggle();
              setOnCancel(true);
            }}
          >
            Close
          </span>
          <span>
            <Link to={redirectLink} target="_blank">
              <Button
                color="primary"
                disabled={!isEditCustomerSupplierPresent}
                onClick={() => {
                  handleSetLocalStorageData();
                }}
              >
                Edit Details
              </Button>
            </Link>
          </span>
        </ModalFooter>
      </Modal>
      {fetching && <Loader />}
    </>
  );
};

export default ViewEditCustomerSuplierModal;
